import { useEffect } from 'react';

import { handleSignOut } from 'app/components/NavBar/utils';
import Cookies from 'universal-cookie';

import useIsLoggedIn from './useIsLoggedIn';

export default function useCatchExpiredToken() {
  const { isLoggedIn } = useIsLoggedIn();

  const handleSessionTimeout = () => {
    handleSignOut();
  };

  useEffect(() => {
    window.addEventListener('focus', () => {
      const cookies = new Cookies();
      const JWT = cookies.get('auth-token');
      if (JWT === undefined && isLoggedIn) {
        handleSessionTimeout();
      }
    });

    return () => {
      window.removeEventListener('focus', () => {});
    };
  }, [isLoggedIn]);
}
